import gql from 'graphql-tag';

import type { LongFormDraft } from 'src/data/longForm/types';
import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendMutationApplyFormatToLongFormDraftArgs } from 'src/types/backend';

import { FRAGMENT_LONG_FORM_BUILDER_DRAFT } from './schema';

const MUTATION = gql`
  mutation ApplyFormatToLongFormDraft($id: ID!) {
    applyFormatToLongFormDraft(id: $id) {
      ...LongFormBuilderDraft
    }
  }
  ${FRAGMENT_LONG_FORM_BUILDER_DRAFT}
`;

type Variables = BackendMutationApplyFormatToLongFormDraftArgs;
type Result = LongFormDraft;

export const applyFormatToLongFormDraft = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });

  return getSingleProp<Result>(result.data);
};
